<template lang="html">
  <div class="">
    <si-container back="/consulting">
      <v-layout
        wrap
        ma-0
      >
        <v-flex
          xs12
          md4
        >
          <v-layout column>
            <v-flex>
              <v-card>
                <v-card-title>{{ clientName }}</v-card-title>  
          
                <v-list
                  dense
                  class="transparent"
                >
                  <v-list-item
                    v-if="client.phone"
                    :href="`tel:${client.phone}`"
                  >
                    <v-list-item-action> <v-icon>phone</v-icon> </v-list-item-action>
                    <v-list-item-title>{{ client.phone }}</v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    v-if="client.email"
                    :href="`mailto:${client.email}`"
                  >
                    <v-list-item-action> <v-icon>email</v-icon> </v-list-item-action>
                    <v-list-item-title>{{ client.email }}</v-list-item-title>
                  </v-list-item>
                </v-list>
                <v-divider />
                <v-card-subtitle>Service</v-card-subtitle>
                <v-card-text class="text-subtitle-1 text--primary">
                  {{ appointment.serviceName }}
                </v-card-text>
                <v-divider />
                <v-card-subtitle>
                  <v-layout ma-0>
                    Payment
                    <v-spacer />
                    <v-chip
                      small
                      :color="paymentStatus.color"
                      :outlined="paymentStatus.outlined"
                    >
                      <v-icon left>
                        {{ paymentStatus.icon }}
                      </v-icon>
                      {{ paymentStatus.text }}
                    </v-chip>  
                  </v-layout>
                </v-card-subtitle>
                <v-card-text>
                  <v-layout align-center>
                    <v-flex class="title">
                      {{ _$(appointment.price) }} 
                    </v-flex>
                    <v-flex shrink>
                      <v-menu
                        v-if="appointment._paid && payment.source === 'stripe'"
                        offset-y
                      >
                        <template #activator="{ on, attrs }">
                          <v-btn
                            icon
                            v-bind="attrs"
                            v-on="on"
                          >
                            <v-icon>more_vert</v-icon>
                          </v-btn>
                        </template>
                        <v-list>
                          <v-list-item @click="refundDialog = true">
                            <v-list-item-title>Create refund</v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </v-flex>
                  </v-layout>
                  <div v-if="payment.method">
                    <v-divider class="my-2" />
                    <v-layout
                      class="align-center"
                      wrap
                    >
                      <v-flex
                        mr-4
                        shrink
                      > 
                        <div class="caption grey--text">
                          Method
                        </div> 
                        {{ payment.method }} 
                      </v-flex>
                      <v-flex
                        shrink
                        mr-4
                      > 
                        <div class="caption grey--text">
                          Paid
                        </div> 
                        {{ _$(payment.paid_amount) }} 
                      </v-flex>
                      <v-flex
                        v-if="payment.paid_date"
                        mr-4
                        shrink
                      > 
                        <div class="caption grey--text">
                          Date
                        </div> 
                        {{ _formatDateShort(payment.paid_date) }} 
                      </v-flex>
                    </v-layout>
                    <div v-if="appointment._refund">
                      <v-divider />
                      <v-layout
                        class="align-center"
                        wrap
                      >
                        <v-flex
                          mr-4
                          shrink
                        > 
                          <div class="caption grey--text">
                            Refund
                          </div> 
                          {{ _$(appointment._refund.amount) }} 
                        </v-flex>
                        <v-flex mr-4> 
                          <div class="caption grey--text">
                            Reason
                          </div> 
                          {{ appointment._refund.reason }} 
                        </v-flex>
                      </v-layout>
                    </div>
                  </div>
                
                  <v-btn
                    v-if="payment.source === 'stripe' && appointment.status === 'canceled' && !appointment._refund"
                    color="error"
                    class="mt-4"
                    depressed 
                    block
                    @click="refundDialog = true"
                  >
                    Refund
                  </v-btn>
                </v-card-text>

                <v-divider />
                <v-card-subtitle>
                  <v-layout ma-0>
                    Appointment
                    <v-spacer />
                    <v-chip
                      small
                      :color="appointmentStatus.color"
                    >
                      <v-icon left>
                        {{ appointmentStatus.icon }}
                      </v-icon>
                      {{ appointmentStatus.text }}
                    </v-chip>   
                  </v-layout>
                </v-card-subtitle>
                <v-card-text class="text--primary">
                  <v-layout align-center>
                    <v-flex>
                      <div>
                        <div class="caption grey--text">
                          Start
                        </div>
                        {{ _formatDateTime(appointment.start) }}
                      </div>
                      <div>
                        <div class="caption grey--text">
                          End
                        </div>
                        {{ _formatDateTime(appointment.end) }}
                      </div>
                    </v-flex>
                    <!-- <v-flex shrink>
                  <v-chip small :color="appointmentStatus.color">
                      <v-icon left>{{appointmentStatus.icon}}</v-icon>
                      {{appointmentStatus.text}}
                  </v-chip>     
                </v-flex> -->
                  </v-layout>
                  <v-flex />
                  <v-btn 
                    block
                    depressed
                    outlined
                    color="deep-purple darken-1 white--text" 
                    :href="appointment.onlineMeetingUrl"
                    target="_blank" 
                  >
                    Join online meeting
                    <v-icon right>
                      people
                    </v-icon>
                  </v-btn>
                </v-card-text>
                <div v-if="appointment.status === 'confirmed'">
                  <v-divider />
                  <v-card-text>
                    <v-btn
                      color="primary"
                      depressed 
                      block
                      @click="setComplete"
                    >
                      Mark complete
                    </v-btn>
                  </v-card-text>
                </div>
              </v-card>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex
          xs12
          md8
        >
          <Attachments
            :id="appointment.id"
            :appointment-path="appointmentPath"
          />
        </v-flex>
      </v-layout>
    </si-container>
    <v-snackbar
      v-model="snackbar"
      :timeout="2000"
    >
      Value copied
    </v-snackbar>

    <v-dialog
      v-model="refundDialog"
      persistent
      max-width="500"
      style="width: 100%;"
      scrollable
    >
      <v-card class="grey lighten-4">
        <v-card-title class="headline warning white--text">
          <v-icon class="white--text mr-2">
            warning
          </v-icon>Refund
        </v-card-title>
        <v-card-text class="pa-6">
          <v-layout wrap>
            <v-flex xs12>
              <SiInputCurrency
                v-model="refund.amount"
                label="Refund amount"
                cents
                outlined
                :error-messages="refundValidation"
              />
            </v-flex>
            <v-flex xs12>
              <SiInputTextarea
                v-model="refund.reason"
                label="Refund reason"
                outlined
              />
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="grey"
            text
            @click.native="refundDialog = false"
          >
            Cancel
          </v-btn>
          <v-btn
            color="warning"
            :disabled=" refund.amount === 0 || !refund.reason || refund.amount > payment.total"
            @click.native="raiseRefund(payment.source)"
          >
            Raise refund
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <SiLoaderPopup
      :value="refundProcessing"
      color="warning"
      label="Processing Refund"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
// import moment from 'moment'
import { rtdb } from "@/plugins/firebase";
import helpers from "@/mixins/helpers";
import users from "@/mixins/users";
import binder from "@/mixins/binder";
import mixins from "./mixins";
import Attachments from "./Attachments.vue";
import { db } from "@/plugins/firebase";

export default {
  components: {
    Attachments,
  },
  mixins: [mixins, helpers, users, binder],
  data() {
    return {
      files: [],
      appointment: {},
      refundDialog: false,
      snackbar: false,
      invoiceLoading: false,
      loading: true,
      refundProcessing: false,
      refund: {
        amount: 0,
        reason: "",
      },
      note: "",
      paymentStatusDisplay: {
        paid: { text: "Paid", color: "success" },
        pending: { text: "Pending", color: "warning" },
        refunded: { text: "Refunded", color: undefined },
      },
      appointmentStatusDisplay: {
        confirmed: { text: "Confirmed", color: "success" },
        canceled: { text: "Cancelled", color: "error" },
        complete: { text: "Complete", color: undefined },
      },
    };
  },
  computed: {
    ...mapGetters(["_loader", "_user", "_badgeTotals"]),
    appointmentId() {
      return this.$route.params.sub || "";
    },
    clientName() {
      return (
        this.appointment.clientName ||
        `${this.client.firstName || ""} ${this.client.lastName || ""}`
      );
    },
    client() {
      return (this.appointment || {}).client || {};
    },
    payment() {
      return this.appointment._payment || {};
    },
    paymentStatus() {
      return this._paymentStatus(this.appointment.paymentStatus);
    },
    appointmentStatus() {
      return this._appointmentStatus(this.appointment.status);
    },
    refundValidation() {
      if (this.refund.amount > this.payment.total)
        return ["Refund amount cannot be greater than total payment"];
      return [];
    },
    appointmentPath() {
      return this.appointmentId
        ? `services/consulting/appointments/${this.appointmentId}`
        : null;
    },
  },
  watch: {
    "$route.params.sub"() {
      this.invoiceLoading = false;
      this.interactionComment = "";
      this.bindAppointment();
    },
    refundDialog() {
      console.log(this.payment);
      this.refund.amount = this.payment.total;
    },
  },
  beforeMount() {
    this.bindAppointment();
  },
  methods: {
    bindAppointment() {
      // this.$unbindAll();
      if (this.appointmentId) {
        this.$bindDb("appointment", this.appointmentPath, {
          loader: "loading",
        });
      }
    },
    setComplete() {
      db.doc(this.appointmentPath).set({ status: "complete" }, { merge: true });
    },
    // async markAsPaid() {
    //   this.invoiceLoading = true;
    //   const token = await auth.currentUser.getIdToken();

    //   await axios({
    //     url: `${process.env.VUE_APP_API_URL}/invoices/${this.payment.id}/payment`,
    //     method: "POST",
    //     headers: { Authorization: "Bearer " + token },
    //     data: {
    //       amount: this.payment.total,
    //       source: "console",
    //     },
    //   });
    //   this.invoiceLoading = false;
    // },
    raiseRefund() {
      rtdb.ref(`stripe/refunds/${this.payment.id}/request`).set({
        ...this.refund,
          timestamp: new Date().toISOString()
      });

      this.refundProcessing = true;
      this.refundDialog = false;

      let listener = rtdb
        .ref(`stripe/refunds/${this.payment.id}/outcome`)
        .on("value", (s) => {
          if (s) {
            let outcome = s.val();
            if (
              outcome &&
              outcome.status === "succeeded" &&
              this.refundProcessing
            ) {
              listener();
              this.refundProcessing = false;
            }
          }
        });
    },
  },
};
</script>

<style lang="css" scoped>
</style>
